import { useContext } from "react";
import { LocaleContext } from "./localization_wrapper";

function stepForPageKey(key) {
  if (key === "street" || key === "tellit" || key.startsWith("open")) return 1;
  if (key === "name") return 2;
  if (key === "sociodemo") return 3;
  if (key === "optin" || key === "like") return 4;
  return null;
}

export function Progress({ onBackButton, pageKey }) {
  const i18n = useContext(LocaleContext);
  const step = stepForPageKey(pageKey);

  return (
    <div className="progress">
      <button
        className="progress__back"
        onClick={onBackButton}
        type="button"
        aria-label={i18n.t("general.prev_page_aria")}
        disabled={typeof onBackButton !== "function"}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="progress__back-icon"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M10 18L4 12L10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18Z" />
        </svg>
      </button>
      <p className="progress__step">{step === null ? "" : `${step}/4`}</p>
    </div>
  );
}
